// @flow

import { Map, fromJS } from 'immutable';

export const GET_LOGIN_CODE = 'App/Login/GET_LOGIN_CODE';
export const GET_LOGIN_CODE_SUCCESS = 'App/Login/GET_LOGIN_CODE_SUCCESS';
export const GET_LOGIN_CODE_FAIL = 'App/Login/GET_LOGIN_CODE_FAIL';
export const CHECK_USER_LOGGEDIN = 'App/Login/CHECK_USER_LOGGEDIN';
export const CHECK_USER_LOGGEDIN_SUCCESS = 'App/Login/CHECK_USER_LOGGEDIN_SUCCESS';
export const CHECK_USER_LOGGEDIN_FAIL = 'App/Login/CHECK_USER_LOGGEDIN_FAIL';
export const LOGOUT = 'App/Login/LOGOUT';
export const LOGOUT_SUCCESS = 'App/Login/LOGOUT_SUCCESS';
export const LOGOUT_FAIL = 'App/Login/LOGOUT_FAIL';
export const CLEAR_LOGIN = 'App/Login/CLEAR_LOGIN';

const initialState = Map({
  getLoginCodeLoading: false,
  loginCode: Map({}),
  getLoginCodeFail: null,
  checkUserLoggedinLoading: false,
  authenticationData: Map({}),
  checkUserLoggedinFail: Map({}),
  logoutLoading: false,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_LOGIN_CODE:
      return state.merge({
        getLoginCodeLoading: true,
        getLoginCodeFail: null,
      });
    case GET_LOGIN_CODE_SUCCESS:
      return state.merge({
        getLoginCodeLoading: false,
        loginCode: Map(action.data),
      });
    case GET_LOGIN_CODE_FAIL:
      return state.merge({
        getLoginCodeLoading: false,
        getLoginCodeFail: fromJS(action.data),
      });

    case CHECK_USER_LOGGEDIN:
      return state.set('checkUserLoggedinLoading', true);
    case CHECK_USER_LOGGEDIN_SUCCESS:
      return state.merge({
        checkUserLoggedinLoading: false,
        authenticationData: fromJS(action.data),
      });
    case CHECK_USER_LOGGEDIN_FAIL:
      return state.merge({
        checkUserLoggedinLoading: false,
        checkUserLoggedinFail: fromJS(action.data),
      });

    case LOGOUT:
      return state.set('logoutLoading', true);
    case LOGOUT_SUCCESS:
      return state.merge({
        authenticationData: Map({}),
        logoutLoading: false,
      });
    case LOGOUT_FAIL:
      return state.set('logoutLoading', true);

    default:
      return state;
  }
};

export const getLoginCode = (refrenceRoute : string, response : any = null) =>
  (dispatch : any) =>
    dispatch({ type: GET_LOGIN_CODE, data: { refrenceRoute, response } });

export const clearLogin = () => (dispatch : any) =>
  dispatch({ type: CLEAR_LOGIN });

export const checkUserLoggedin = (data : string) => (dispatch : any) =>
  dispatch({ type: CHECK_USER_LOGGEDIN, data });

export const logout = () => (dispatch : any) =>
  dispatch({ type: LOGOUT });
